import { Suspense, lazy } from 'react';
import Landing from './pages/Landing';
import { parseShareId } from './lib/navigation';

// The viewer (image stage, zoom/pinch, tracking) ships as its own chunk so
// the landing page stays light and static-feeling.
const Viewer = lazy(() => import('./pages/Viewer'));

export default function App() {
  const shareId = parseShareId(window.location.pathname);
  if (shareId) {
    return (
      <Suspense
        fallback={
          <div className="viewer-boot" role="status" aria-label="Loading viewer">
            <span className="spinner" aria-hidden="true" />
          </div>
        }
      >
        <Viewer shareId={shareId} />
      </Suspense>
    );
  }
  return <Landing />;
}
